import React from "react";
import { Stepper, Step, StepLabel, Button } from "@mui/material";
import clsx from "clsx";

const ShareStepper = ({ steps, activeStep, onNext, onBack }) => {
  const handleNext = () => {
    onNext();
  };

  const handleBack = () => {
    onBack();
  };

  const isLastStep = activeStep === steps.length - 1;

  return (
    <div className=" w-2/3 mx-auto">
      <Stepper activeStep={activeStep} className="bg-white">
        {steps.map((label, index) => (
          <Step key={index} color="secondary">
            <StepLabel className="text-primary">{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <style jsx>{`
        .MuiStepIcon-root {
          color: rgb(var(--c-primary));
          width: 30px;
          height: 30px;
        }

        .Mui-active {
          color: rgb(var(--c-primary)) !important;
        }

        .Mui-completed {
          color: rgb(var(--c-primary)) !important;
        }
      `}</style>
    </div>
  );
};

export default ShareStepper;
